var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "dsf-question-item" },
    [
      _c("div", { staticClass: "dsf-exam-title" }, [
        _c(
          "div",
          { staticClass: "exam-title" },
          [
            _c("div", [
              _vm._v(
                _vm._s(
                  _vm.itemsType
                    ? "（" + _vm.examIndex + "）"
                    : _vm.examIndex + ". "
                )
              ),
            ]),
            _c(
              "el-popover",
              {
                ref: "popover",
                attrs: {
                  placement: "right",
                  trigger: "hover",
                  width: "200",
                  disabled: !_vm.titleImg,
                  "popper-options": {
                    boundariesElement: "viewport",
                    removeOnDestroy: true,
                  },
                },
              },
              [
                _c(
                  "el-image",
                  { attrs: { src: _vm.dsf.url.getWebPath(_vm.titleImg) } },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "image-slot",
                        attrs: { slot: "error" },
                        slot: "error",
                      },
                      [
                        _c("i", {
                          staticClass:
                            "iconfont icon-tupianjiazaishibai err-img",
                        }),
                      ]
                    ),
                  ]
                ),
              ],
              1
            ),
            _vm.subjects.items.value !== "input"
              ? _c("div", {
                  directives: [
                    {
                      name: "popover",
                      rawName: "v-popover:popover",
                      arg: "popover",
                    },
                  ],
                  staticClass: "title-name",
                  domProps: { innerHTML: _vm._s(_vm.subjects.name) },
                  on: { click: _vm.showImage, mouseover: _vm.showPopver },
                })
              : _vm._e(),
          ],
          1
        ),
        !_vm.readOnly || _vm.type == "practice"
          ? _c(
              "div",
              { staticClass: "icon-button" },
              [
                _vm.showConsult
                  ? _c("i", {
                      class: [
                        "tools iconfont icon-icon_ct",
                        _vm.showStatus ? "active" : "",
                      ],
                      attrs: { title: "查阅" },
                      on: {
                        click: function ($event) {
                          return _vm.handlerEvent("consult", _vm.subjects)
                        },
                      },
                    })
                  : _vm._e(),
                !_vm.hideMark
                  ? _c("i", {
                      class: [
                        "tools iconfont icon-biaoji",
                        _vm.subjects.marked ? "active" : "",
                      ],
                      attrs: { title: "标记" },
                      on: {
                        click: function ($event) {
                          return _vm.handlerEvent("mark", _vm.subjects)
                        },
                      },
                    })
                  : _vm._e(),
                _c(
                  "el-popover",
                  {
                    ref: "popover-" + _vm.subjects.examQuestionsId,
                    staticClass: "error-pop",
                    attrs: {
                      "append-to-body": false,
                      "popper-class": "correct-review",
                      placement: "left-end",
                      width: "300",
                      trigger: "click",
                    },
                    on: { "after-leave": _vm.closeHander },
                  },
                  [
                    _vm.correctReview
                      ? _c("dsf-view-part", {
                          attrs: {
                            independent: true,
                            "is-open-dialog": true,
                            path: _vm.correctReviewUrl,
                            "show-model": "full",
                          },
                        })
                      : _vm._e(),
                    _c("i", {
                      staticClass: "tools iconfont icon-icon_ct",
                      attrs: { slot: "reference", title: "纠错" },
                      on: {
                        click: function ($event) {
                          return _vm.handlerEvent("error", _vm.subjects)
                        },
                      },
                      slot: "reference",
                    }),
                  ],
                  1
                ),
                (_vm.type == "practice" || _vm.exam.showHint) &&
                _vm.subjects.hint
                  ? _c("i", {
                      staticClass: "tools iconfont icon-icon_tips1",
                      attrs: { title: "提示" },
                      on: {
                        click: function ($event) {
                          return _vm.handlerEvent("tips", _vm.subjects)
                        },
                      },
                    })
                  : _vm._e(),
              ],
              1
            )
          : _vm._e(),
      ]),
      _c(_vm.componentIs[_vm.subjects.items.value], {
        tag: "component",
        attrs: {
          previewStatus: _vm.previewStatus,
          readOnly: _vm.readOnly,
          subjects: _vm.subjects,
          "items-type": _vm.itemsType,
        },
        on: { "show-image": _vm.showImage },
      }),
      _vm.subjects.showStatus || _vm.showStatus
        ? _c("div", { staticClass: "exam-answer-analysis" }, [
            _c(
              "div",
              [
                _vm.subjects.items.value != "subjective"
                  ? [
                      _c("span", { staticClass: "answer" }, [
                        _vm._v(" 标准答案 "),
                      ]),
                      _c("span", { staticClass: "value" }, [
                        _vm._v(_vm._s(_vm.subjects.answerValue)),
                      ]),
                    ]
                  : _vm._e(),
                _vm.type !== "practice"
                  ? _c("span", { staticClass: "res-score" }, [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.showScore
                              ? "本题得分：" +
                                  (_vm.subjects.resScore !== null
                                    ? _vm.subjects.resScore
                                    : "")
                              : ""
                          ) +
                          " "
                      ),
                    ])
                  : _vm._e(),
              ],
              2
            ),
            _c("div", {
              staticClass: "analysis",
              domProps: {
                innerHTML: _vm._s(
                  "试题解析：" +
                    (_vm.subjects.parse === null ? "" : _vm.subjects.parse)
                ),
              },
              on: { click: _vm.showImage },
            }),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }